import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux';
import Drawer from '@mui/material/Drawer';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import Alert from '@mui/material/Alert';
import Typography from '@mui/material/Typography';
import { Tooltip } from "@mui/material";
import InfoIcon from '@mui/icons-material/Info';
import Snackbar from '@mui/material/Snackbar';
import Box from '@mui/material/Box';
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import LinearProgress from '@mui/material/LinearProgress';
import {
    DataGrid,
    GridToolbarContainer
} from '@mui/x-data-grid';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import Carrier from '../../pages/General/Carrier'
import Notification from '../../pages/General/Notification'
import NorowsData from '../../pages/General/NorowsData'
import Printer from '../../pages/General/Printer'
import { doGetRate, resetRateState } from '../../pages/Shipments/NewShipment/rateSlice';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { generateLabel, resetGenerateLabel } from '../../pages/Shipments/NewShipment/createShipmentSlice';
import { dopostDataCreateShipment } from '../../pages/Orders/ordersSlice';

const RateDrawer = ({ visible, reportName, formDataValues, onClose, newOrderFormData, meta, isDuplicateOrder,isReturnOrder, lineItemId, customLineItems, setValues,setNewOrderFormData, setCustomLineItems, setRateDrawervisible = () => { }, setNewOrderCreateDrawerVisible = () => { },isFailedShipment=false,isShipmentCreationFlow=false }) => {
    const dispatch = useDispatch();
    const orders = useSelector(state => state.orders.createShipment);
    const rates = useSelector(state => state.rates);
    const profile = useSelector(state => state.auth);
    const createshipment = useSelector(state => state.createshipment);
    const [rateData, setRateData] = useState([]);
    const [labelShowData, setLabelShowData] = useState(false);
    const [drawer, setDrawer] = useState(true);
    const [snackOpen, setsnackOpen] = useState(false);
    const [printUrl, setPrintUrl] = useState("")
    const [isPrinted, setIsPrinted] = useState(true)
    const [isLabelOpened, setIsLabelOpened] = useState(true)
    const [isFailedLabelPrinted, setIsFailedLabelPrinted] = useState(true)
    const initialFValues = {
        name: '',
        company: '',
        phone: '',
        email: '',
        address: '',
        address2: '',
        city: '',
        postal_code: '',
        country_code: '',
        weight: '',
        box_weight: '',
        actual_weight: '',
        province: '',
        preferred_sender_id: '',
        length: '',
        height: '',
        width: '',
        dimension_unit: 'in',
        weight_unit: 'lb',
        insurance_amount: "",
        choosemeasurement: '',
        preferred_carrier: '',
        preferred_carrier_reference_id: '',
        preferred_service: '',
        sender_reference_no:'',
        return_shipment_sender_id:"",
        shipment_type:"PACKAGE",
        is_signature_required:"",
    }
    const ondrawerclose = () => {
        setDrawer(false)
        onClose(false)
        // dispatch(resetRateState())
        dispatch(resetGenerateLabel())
    }

    const toggleDrawer = (anchor, open) => (event) => {
        let hidedrawer = ''
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
    };

    useEffect(() => {
        if (rates && rates.message && rates.message.length !== 0) {
            setsnackOpen(true)
        }
    }, [rates]);

    const handleClose = () => {
        dispatch(resetRateState())
        setsnackOpen(false)
    };

    function generateCustomRef() {
        // Generate a 24-character hex string
        const randomHex = [...Array(24)]
          .map(() => Math.floor(Math.random() * 16).toString(16))
          .join('');
      
        // Get current datetime in YYYYMMDDHHmmss format
        const now = new Date();
        const datetime =
          now.getFullYear().toString() +
          String(now.getMonth() + 1).padStart(2, '0') +
          String(now.getDate()).padStart(2, '0') +
          String(now.getHours()).padStart(2, '0') +
          String(now.getMinutes()).padStart(2, '0') +
          String(now.getSeconds()).padStart(2, '0');
        // Combine everything
        return `SCREF${randomHex}${datetime}`;
      }

    const generatelabel = (rate_row,status) => {
        let apikey = (profile.profile.api_token) ? profile.profile.api_token : "";
        const formData = formDataValues;
        let referenceno = ""
        let preferred_carrier = ""
        let fetch_rate_request_id=""
        fetch_rate_request_id=rates && rates.data && rates.data.fetch_rate_request_id ? rates.data.fetch_rate_request_id :""
        if(!isDuplicateOrder && newOrderFormData && newOrderFormData.reference && newOrderFormData.reference.no){
            referenceno = newOrderFormData.reference.no
        }

        let order_id_check=""
        let document_reference={}
        if(isReturnOrder){
            order_id_check=(newOrderFormData && newOrderFormData.order && newOrderFormData.order.id)
                ? "R"+newOrderFormData.order.id : ""
            document_reference={
                "doc_id": "",
                "order_id": order_id_check,
                "item_ids": lineItemId,
                "is_failed_bulk_order": (newOrderFormData && newOrderFormData.order && newOrderFormData.order.status && newOrderFormData.order.status == "Label Generation Failed") ? true : false,
                "item_reference_id":formData.item_reference_id,
                "parent_userid":(newOrderFormData && newOrderFormData.userid) ? newOrderFormData.userid : ""
            }
        }else if(isDuplicateOrder){
            document_reference={
                "doc_id": "",
                "order_id": "",
                "item_ids": lineItemId,
                "is_failed_bulk_order": (newOrderFormData && newOrderFormData.order && newOrderFormData.order.status && newOrderFormData.order.status == "Label Generation Failed") ? true : false,
                "item_reference_id":formData.item_reference_id,
                "parent_userid":(newOrderFormData && newOrderFormData.userid) ? newOrderFormData.userid : ""
            }
        }else{
            order_id_check=(newOrderFormData && newOrderFormData.order && newOrderFormData.order.id)
            ? newOrderFormData.order.id : ""
            document_reference={
                "doc_id": (newOrderFormData && newOrderFormData._id) ? newOrderFormData._id : "",
                "order_id": order_id_check,
                "item_ids": lineItemId,
                "is_failed_bulk_order": (newOrderFormData && newOrderFormData.order && newOrderFormData.order.status && newOrderFormData.order.status == "Label Generation Failed") ? true : false,
                "item_reference_id": (newOrderFormData && newOrderFormData._id) ? newOrderFormData._id : formData.item_reference_id,
                "parent_userid":(newOrderFormData && newOrderFormData.userid) ? newOrderFormData.userid : ""
            }
        }
        if(status=='LabelFailed'){
            setIsFailedLabelPrinted(false)
            setDrawer(false)
            onClose(false)
            setRateDrawervisible(false)
            setNewOrderCreateDrawerVisible(false)
        }else{
            setIsFailedLabelPrinted(true)
        }
        
        const ratedata = {
            "quantity": "1",
            "referenceno": formData.sender_reference_no!=='' ? formData.sender_reference_no:referenceno,
            "preferred_service": rate_row.id,
            "fetch_rate_request_id":fetch_rate_request_id,
            "request_cheapest_carrier" : false,
            "standard_service_only": false,
            "reference": document_reference,
            "subuser_id":profile.profile.id,
            "shipment_created_method":"FETCH_RATE_CREATE_SHIPMENT"
        }
        if(isShipmentCreationFlow && document_reference && document_reference.is_failed_bulk_order && document_reference.is_failed_bulk_order===true){
            ratedata["bulk_reference_id"] = newOrderFormData && newOrderFormData.shipment_summary && newOrderFormData.shipment_summary.bulk && newOrderFormData.shipment_summary.bulk.reference_id
            ratedata["internal_bulk_serial_number"] = newOrderFormData && newOrderFormData.shipment_summary && newOrderFormData.shipment_summary.bulk && newOrderFormData.shipment_summary.bulk.serial_number
            ratedata["internal_bulk_serial_number_reference"] = newOrderFormData && newOrderFormData.shipment_summary && newOrderFormData.shipment_summary.bulk && newOrderFormData.shipment_summary.bulk.serial_number_reference
        }
        if (customLineItems.length != 0) {
            ratedata["line_items"] = []
        }
        const mergeobjectdata = Object.assign(formData, ratedata);
        dispatch(dopostDataCreateShipment(reportName,profile.profile.id,order_id_check,mergeobjectdata, apikey, meta))
        // dispatch(generateLabel(mergeobjectdata, apikey));
        setLabelShowData(true)
        setIsLabelOpened(false);
    }

    const renderDutyTooltip = (dutyBreakdown) => {
        if (!dutyBreakdown || typeof dutyBreakdown !== 'object') return null;

        const elements = [];
        // Unwrap from array if nested inside [ { ... } ]
        const actualBreakdown = Array.isArray(dutyBreakdown) ? dutyBreakdown[0] : dutyBreakdown;

        if (!actualBreakdown) return null;

        Object.entries(actualBreakdown).forEach(([key, val]) => {
            if (val === undefined || val === null || val === "") return;

            // Strip index numbers (e.g. "DUTY_1" -> "DUTY")
            const cleanKey = key.replace(/_\d+$/, ''); 
            
            let formattedKey = cleanKey
                .split('_')
                .map(word => word.charAt(0).toUpperCase() + word.toLowerCase().slice(1))
                .join(' ');

            // Rename Zonos Markup to SC Fee
            if (formattedKey === "Zonos Markup") {
                formattedKey = "SC Fee";
            }

            if (typeof val === 'object' && !Array.isArray(val)) {
                const resolvedValue = val.value !== undefined ? val.value : (val.amount !== undefined ? val.amount : val.price);
                if (resolvedValue !== undefined && resolvedValue !== null && resolvedValue !== "") {
                    const currencyStr = val.currency ? ` ${val.currency}` : "";
                    elements.push(`${formattedKey}: ${resolvedValue}${currencyStr}`);
                }
            } else {
                elements.push(`${formattedKey}: ${val}`);
            }
        });

        if (elements.length === 0) return null;

        return (
            <Box sx={{ p: 0.5 }}>
                {elements.map((text, idx) => (
                    <Typography 
                        key={idx} 
                        variant="caption" 
                        display="block" 
                        sx={{ 
                            fontSize: '11px', 
                            color: '#ffffff',
                            whiteSpace: 'nowrap',
                            mb: 0.5
                        }}
                    >
                        {text}
                    </Typography>
                ))}
            </Box>
        );
    };

    let columns = [
        {
            field: 'service_display_name',
            headerName: 'Service Type',
            headerClassName: 'super-app-theme--header',
            flex: 1,
            resizable: false,
            renderCell: (params) => {
                if (params.row.service_display_name) {
                    return params.row.service_display_name
                } else {
                    return "-"
                }
            }
        },
        {
            field: 'total_charges',
            headerName: 'Shipping',
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: 120,
            maxWidth: 120,
            resizable: false,
            renderCell: (params) => {
                if (params.row.total_charges) {
                    return params.row.total_charges
                } else {
                    return "-"
                }
            }
        },
        {
            field: 'action',
            headerName: 'Label',
            flex: 1,
            resizable: false,
            renderCell: (params) => {
                return <>{isFailedShipment && <div className="hide--outline"><Button disabled={orders.loading} variant="outlined"  style={{ margin: '0 15px' }} onClick={(event) => {
                    generatelabel(params.row,"LabelFailed")
                }
                }> <AddCircleOutlineOutlinedIcon style={{
                    paddingRight: '10px'
                }} /> Create </Button></div>
                }
                <div className="hide--outline"><Button disabled={orders.loading} variant="outlined" onClick={(event) => {
                    generatelabel(params.row,"LabelSuccess")
                }
                }> <AddCircleOutlineOutlinedIcon style={{
                    paddingRight: '10px'
                }} /> Create + Print </Button></div></>

            }
        }
    ];
    if(profile && profile.profile && (profile.profile.hide_carrier === false)){
        columns.splice(0, 0, {
            field: 'carrier_display_name',
            headerName: 'Carrier Name',
            headerClassName: 'super-app-theme--header',
            flex: 1,
            renderCell: (params) => {
                if (params.row.carrier_display_name) {
                    return params.row.carrier_display_name
                } else {
                    return "-"
                }
            }
        })
    }
    if (profile && profile.profile && (
        (typeof profile.profile.is_sc_ddp_enabled !== "undefined" && profile.profile.is_sc_ddp_enabled == true) || 
        (typeof profile.profile.is_sc_myparcel_ddp_enabled !== "undefined" && profile.profile.is_sc_myparcel_ddp_enabled == true)
    )) {
        let duties_length = columns.length - 1;
        columns.splice(duties_length, 0, {
            field: 'currency_code',
            headerName: 'Duties',
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: 120,
            maxWidth: 120,
            resizable: false,
            renderCell: (params) => {
                const isDdpEnabled = profile.profile.is_sc_ddp_enabled === true || profile.profile.is_sc_myparcel_ddp_enabled === true;
                
                // Check if duty charges exist and have a valid non-zero charge
                const totalCharge = params.row.duty_charges?.total_charge;
                const hasDuties = isDdpEnabled && totalCharge !== undefined && totalCharge !== null && parseFloat(totalCharge) > 0;

                if (hasDuties) {
                    // Generate tooltip content on-the-fly from the row data
                    const dutyTooltipContent = renderDutyTooltip(params.row.duty_breakdown);

                    return (
                        <Box 
                            sx={{ 
                                display: 'flex', 
                                alignItems: 'center', 
                                justifyContent: 'center', // Centers the content together in the cell
                                width: '100%', 
                                height: '100%',
                                gap: 0.75 // Creates a clean, tight professional gap between number and icon
                            }}
                        >
                            <Typography variant="body2" sx={{ fontWeight: 500 }}>
                                {totalCharge}
                            </Typography>
                            {dutyTooltipContent && (
                                <Tooltip title={dutyTooltipContent} placement="top" arrow>
                                    <InfoIcon 
                                        sx={{ 
                                            color: '#919eab', 
                                            fontSize: 16, 
                                            cursor: 'help',
                                            display: 'inline-block',
                                            verticalAlign: 'middle'
                                        }} 
                                    />
                                </Tooltip>
                            )}
                        </Box>
                    );
                } else {
                    return (
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100%' }}>
                            <Typography variant="body2">-</Typography>
                        </Box>
                    );
                }
            }
        });
    }

    if (
        profile && 
        profile.profile && 
        typeof profile.profile.sum_shipping_and_duties !== "undefined" && 
        profile.profile.sum_shipping_and_duties === true && (
            (typeof profile.profile.is_sc_ddp_enabled !== "undefined" && profile.profile.is_sc_ddp_enabled === true) || 
            (typeof profile.profile.is_sc_myparcel_ddp_enabled !== "undefined" && profile.profile.is_sc_myparcel_ddp_enabled === true)
        )
    ) {
        // Locate the 'Duties' column dynamically to place the 'Total' column immediately after it
        const dutiesColumnIndex = columns.findIndex(col => col.field === 'currency_code');
        
        if (dutiesColumnIndex !== -1) {
            columns.splice(dutiesColumnIndex + 1, 0, {
                field: 'shipping_and_duties_total',
                headerName: 'Total',
                headerClassName: 'super-app-theme--header',
                flex: 1,
                minWidth: 120,
                maxWidth: 120,
                resizable: false,
                renderCell: (params) => {
                    // Safe Check: If params or params.row is missing completely
                    if (!params || !params.row) return "-";

                    // 1. Safe parsing for Shipping Charges
                    let shippingCharges = 0;
                    if (params.row.total_charges !== undefined && params.row.total_charges !== null) {
                        shippingCharges = parseFloat(String(params.row.total_charges).replace(/[^\d.-]/g, '')) || 0;
                    }

                    // 2. Safe parsing for Duty Charges (Uses optional chaining to avoid nested property errors)
                    let dutyCharges = 0;
                    if (params.row.duty_charges?.total_charge !== undefined && params.row.duty_charges?.total_charge !== null) {
                        dutyCharges = parseFloat(String(params.row.duty_charges.total_charge).replace(/[^\d.-]/g, '')) || 0;
                    }

                    // 3. Fallback: If both fields are totally missing or empty in row object, show hyphen
                    if (!params.row.hasOwnProperty('total_charges') && !params.row.hasOwnProperty('duty_charges')) {
                        return "-";
                    }

                    const combinedTotal = shippingCharges + dutyCharges;
                    return combinedTotal.toFixed(2);
                }
            });
        }
    }
    useEffect(() => {
        if (orders && orders.notification && orders.notification.messageContent && orders.notification.messageContent[0] === 'Shipment Created Successfully' && visible == true && isLabelOpened == false && isFailedLabelPrinted==true) {
            setIsLabelOpened(true);
            setPrintUrl(orders && orders.message && orders.message.label_carrier)
            setIsPrinted(false)
            setDrawer(false)
            onClose(false)
            setRateDrawervisible(false)
            setNewOrderCreateDrawerVisible(false)
            setCustomLineItems([])
            setValues(initialFValues)
            setNewOrderFormData("")
        }
    }, [orders]);

    return (
        <>
            <Printer isPrinted={isPrinted} setIsPrinted={setIsPrinted} print_url={printUrl} />
            <Drawer
                anchor="right"
                open={visible}
                onClose={(event, reason) => {
                    if (reason !== "backdropClick") {
                        ondrawerclose();
                    }
                }}
                PaperProps={{
                    sx: { width: "70%", bgcolor: '#F8FAFC' },
                }}
            >
                {/* Layout Wrapper Container */}
                <Box sx={{ p: 4, boxSizing: 'border-box' }}>
                    
                    {/* Real-time Toast Notifications Hub Component Area */}
                    {(rates && rates.notification && rates.notification.show && rates.notification.show===true) &&
                        <Notification
                            is_open={rates.notification.show}
                            messageType={rates.notification.messageType}
                            messages={rates.notification.messageContent}
                            handleClose={() => dispatch(resetRateState())}
                        />
                    }

                    {/* ==================== CONDITIONAL VIEW A: OPERATIONAL RATE INDEX LISTINGS ==================== */}
                    {(createshipment.notification.messageContent.length === 0 || createshipment.notification.messageType === 'error') &&
                        <Stack spacing={3}>
                            <Card 
                                sx={{ 
                                    backgroundColor: '#FFFFFF',
                                    border: '1px solid #E2E8F0',
                                    borderRadius: '16px',
                                    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.03)',
                                    overflow: 'hidden'
                                }} 
                                className="sc--cardhead--details"
                            >
                                <CardHeader 
                                    title={
                                        <Typography variant="h6" component="h1" sx={{ fontWeight: 800, color: '#0F172A', fontSize: '16px', m: 0 }}>
                                            Rates
                                        </Typography>
                                    } 
                                    action={
                                        <Tooltip title="Close Panel" placement="top">
                                            <IconButton 
                                                aria-label="close" 
                                                onClick={ondrawerclose}
                                                sx={{ 
                                                    color: '#64748B', 
                                                    borderRadius: '8px', 
                                                    border: '1px solid #E2E8F0',
                                                    p: 0.75,
                                                    transition: 'all 0.15s ease-in-out',
                                                    '&:hover': { backgroundColor: '#F1F5F9', color: '#1E293B', borderColor: '#CBD5E1' }
                                                }}
                                            >
                                                <CloseIcon sx={{ fontSize: '18px' }} />
                                            </IconButton>
                                        </Tooltip>
                                    }
                                    sx={{ p: 2.5, backgroundColor: '#FFFFFF' }}
                                />
                                <Divider sx={{ borderColor: '#E2E8F0' }} />
                            </Card>

                            <Card sx={{ border: '1px solid #E2E8F0', borderRadius: '16px', overflow: 'hidden', boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.03)' }}>
                                <DataGrid 
                                    sx={{ 
                                        width: '100%',
                                        border: 'none',
                                        backgroundColor: '#FFFFFF',
                                        overflow: 'hidden',
                                        '& .MuiDataGrid-topContainer': { backgroundColor: '#F8FAFC', '&::after': { display: 'none' } },
                                        '& .MuiDataGrid-columnHeaders': { backgroundColor: '#F8FAFC', borderBottom: '1px solid #E2E8F0' },
                                        '& .MuiDataGrid-columnHeader': { color: '#475569', fontWeight: 700, fontSize: '13px', '&:focus, &:focus-within': { outline: 'none' } },
                                        '& .MuiDataGrid-row': { transition: 'background-color 0.15s ease-in-out', borderBottom: '1px solid #F1F5F9', alignItems: 'center', '&:hover': { backgroundColor: '#F8FAFC' } },
                                        '& .MuiDataGrid-cell': { borderBottom: 'none', display: 'flex', alignItems: 'center', py: '12px', '&:focus, &:focus-within': { outline: 'none' } },
                                        '& .MuiLinearProgress-root': { height: '3px', backgroundColor: '#E2E8F0', '& .MuiLinearProgress-bar': { backgroundColor: '#1976d2' } }
                                    }}
                                    disableRowSelectionOnClick={true}
                                    getRowId={(row) => row.id}
                                    rows={rates?.data || []}
                                    columns={columns}
                                    columnVisibilityModel={{
                                        action: reportName === 'DASHBOARD_FETCH_RATES' ? false : true, // Hides the action column
                                        total_charges: profile && profile.profile && profile.profile.hide_rate === true  ? false : true, 
                                    }}
                                    autoHeight={true}
                                    hideFooter={true}
                                    slots={{
                                        loadingOverlay: LinearProgress,
                                        noRowsOverlay: NorowsData
                                    }}
                                    loading={!!((rates && rates.loading) || (orders && orders.loading))}
                                />
                            </Card>
                        </Stack>
                    }

                    {/* ==================== CONDITIONAL VIEW B: SUCCESSFUL LABEL CREATION RESOLUTION ==================== */}
                    {(createshipment.notification.messageContent).length !== 0 && (createshipment.notification.messageType !== 'error') &&
                        <Stack spacing={3}>
                            <Card 
                                sx={{ 
                                    backgroundColor: '#FFFFFF',
                                    border: '1px solid #E2E8F0',
                                    borderRadius: '16px',
                                    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.03)',
                                    overflow: 'hidden'
                                }} 
                                className="sc--cardhead--details"
                            >
                                <CardHeader 
                                    title={
                                        <Typography variant="h6" component="h1" sx={{ fontWeight: 800, color: '#0F172A', fontSize: '16px', m: 0 }}>
                                            Labels
                                        </Typography>
                                    } 
                                    action={
                                        <Tooltip title="Close Panel" placement="top">
                                            <IconButton 
                                                aria-label="close" 
                                                onClick={ondrawerclose}
                                                sx={{ 
                                                    color: '#64748B', 
                                                    borderRadius: '8px', 
                                                    border: '1px solid #E2E8F0',
                                                    p: 0.75,
                                                    transition: 'all 0.15s ease-in-out',
                                                    '&:hover': { backgroundColor: '#F1F5F9', color: '#1E293B', borderColor: '#CBD5E1' }
                                                }}
                                            >
                                                <CloseIcon sx={{ fontSize: '18px' }} />
                                            </IconButton>
                                        </Tooltip>
                                    }
                                    sx={{ p: 2.5, backgroundColor: '#FFFFFF' }}
                                />
                                <Divider sx={{ borderColor: '#E2E8F0' }} />
                            </Card>

                            <Card 
                                sx={{ 
                                    backgroundColor: '#FFFFFF',
                                    border: '1px solid #E2E8F0',
                                    borderRadius: '16px',
                                    boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.05), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
                                    overflow: 'hidden'
                                }} 
                                className="sc--cardhead--details"
                            >
                                <Box sx={{ p: 5, display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
                                    
                                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', p: 1.5, bgcolor: 'rgba(46, 125, 50, 0.08)', borderRadius: '50%', mb: 2 }}>
                                        <CheckCircleIcon sx={{ fontSize: '44px', color: '#2E7D32' }} />
                                    </Box>
                                    
                                    <Typography variant="h5" component="h2" sx={{ fontWeight: 800, color: '#0F172A', letterSpacing: '-0.5px', mb: 3 }}>
                                        Successfully generated label
                                    </Typography>
                                    
                                    <Stack spacing={1.5} sx={{ width: '100%', maxWith: '400px', p: 2.5, bgcolor: '#F8FAFC', border: '1px solid #E2E8F0', borderRadius: '12px', mb: 3 }}>
                                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 2 }}>
                                            <Typography variant="caption" sx={{ color: '#64748B', fontWeight: 600, textTransform: 'uppercase' }}>Tracking Number</Typography>
                                            <Typography variant="body2" sx={{ color: '#1E293B', fontWeight: 700, fontFamily: 'monospace', fontSize: '13.5px' }}>
                                                {createshipment && createshipment.order && createshipment.order.trackingnumber}
                                            </Typography>
                                        </Box>
                                        <Divider sx={{ borderColor: '#F1F5F9' }} />
                                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 2 }}>
                                            <Typography variant="caption" sx={{ color: '#64748B', fontWeight: 600, textTransform: 'uppercase' }}>Carrier</Typography>
                                            <Typography variant="body2" sx={{ color: '#1E293B', fontWeight: 700 }}>
                                                {createshipment && createshipment.order && createshipment.order.carrier_name}
                                            </Typography>
                                        </Box>
                                    </Stack>

                                    <Button 
                                        variant="contained"
                                        component="a"
                                        href={createshipment && createshipment.order && createshipment.order.label_carrier}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        startIcon={<RemoveRedEyeIcon sx={{ fontSize: '16px !important' }} />}
                                        sx={{ 
                                            textTransform: 'none', 
                                            borderRadius: '10px', 
                                            fontWeight: 700, 
                                            fontSize: '13.5px', 
                                            height: '38px', 
                                            px: 4, 
                                            boxShadow: 'none', 
                                            bgcolor: '#1976d2', 
                                            color: '#FFFFFF', 
                                            textDecoration: 'none',
                                            '&:hover': { bgcolor: '#115293', boxShadow: 'none' } 
                                        }}
                                    >
                                        View Label
                                    </Button>
                                </Box>
                            </Card>
                        </Stack>
                    }
                </Box>
            </Drawer>
        </>
    )
}


export default RateDrawer;